import { Box, styled, Theme } from "@mui/material";

export const StyledDataGridOOWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasPadding" && prop !== "autoHeight",
})(({ height, autoHeight }: { height?: string | number; autoHeight?: boolean }) => ({
  display: "flex",
  overflow: autoHeight ? "visible" : "auto",
  position: "relative",
  width: "100%",
  minHeight: autoHeight ? "fit-content" : "280px",
  height: height ?? (autoHeight ? "auto" : "100%"),
  paddingBottom: autoHeight ? "2rem" : 0,
  "& .MuiDataGrid-root": {
    minHeight: "unset !important",
  },
  "& .MuiDataGrid-root:has(.MuiDataGrid-overlayWrapper)": {
    minHeight: "unset !important",
  },
  "& .MuiDataGrid-overlayWrapper": {
    minHeight: 0,
    height: "auto !important",
  },
  "& .MuiDataGrid-overlayWrapper:has(.MuiDataGrid-overlayLoadingVariant)": {
    height: "auto !important",
  },
  "& .MuiDataGrid-overlayWrapperInner": {
    height: "auto !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const StyledSubmenuWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hasPadding",
})(({ hasPadding, theme }: { hasPadding?: boolean; theme: Theme }) => ({
  backgroundColor: theme.palette.common.white,
  height: "100%",
  width: "100%",
  maxWidth: "100%",
  overflow: "hidden",
  padding: hasPadding ? "1.5rem 2rem" : 0,
}));
